import {TFunction} from 'i18next';
import {includes} from 'lodash';

import {Language} from 'constants/language';
import {Option} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale/translation-keys';

import {COUNTRY_ICONS} from '../constants';

// TODO: move these keys of out LANGUAGE_SWITCHER
const T_KEYS = TRANSLATION_KEYS.COMPONENTS.LANGUAGE_SWITCHER;

function getLanguageOptions(t: TFunction, exclude: Language[] = []): Option<Language>[] {
    return [{
        id: Language.Arabic,
        name: t(T_KEYS.LANGUAGES.ARABIC),
        icon: COUNTRY_ICONS.AR
    }, {
        id: Language.English,
        name: t(T_KEYS.LANGUAGES.ENGLISH),
        icon: COUNTRY_ICONS.EN
    },
    {
        id: Language.Spanish,
        name: t(T_KEYS.LANGUAGES.SPANISH),
        icon: COUNTRY_ICONS.ES
    },
    {
        id: Language.French,
        name: t(T_KEYS.LANGUAGES.FRENCH),
        icon: COUNTRY_ICONS.FR
    },
    {
        id: Language.Hebrew,
        name: t(T_KEYS.LANGUAGES.HEBREW),
        icon: COUNTRY_ICONS.HE
    },
    {
        id: Language.Portuguese,
        name: t(T_KEYS.LANGUAGES.PORTUGUESE),
        icon: COUNTRY_ICONS.PT
    }].filter((option) => !includes(exclude, option.id));
}

export const languageUtils = {
    getLanguageOptions
};